import { render, staticRenderFns } from "./metrics_header.vue?vue&type=template&id=222dcdc4&scoped=true&"
import script from "./metrics_header.vue?vue&type=script&lang=js&"
export * from "./metrics_header.vue?vue&type=script&lang=js&"
import style0 from "./metrics_header.vue?vue&type=style&index=0&id=222dcdc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222dcdc4",
  null
  
)

export default component.exports